import McGaugeChart from './McGaugeChart';

export default McGaugeChart;
